import { render, staticRenderFns } from "./NotificationPopupWelcome.vue?vue&type=template&id=72761441&scoped=true&lang=pug"
import script from "./NotificationPopupWelcome.vue?vue&type=script&lang=ts"
export * from "./NotificationPopupWelcome.vue?vue&type=script&lang=ts"
import style0 from "./NotificationPopupWelcome.vue?vue&type=style&index=0&id=72761441&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72761441",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle})
